import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";
import usePublicBasedRefundProtectionConfigurationService from "@app-contexts/public/features/checkout/data/services/refund-protection-configuration/usePublicBasedRefundProtectionConfigurationService";
import { DataProvider } from "@shared/constants/common";
import RefundProtection, {
  RefundProtectionProps,
} from "@shared/modules/basket/components/RefundProtection/RefundProtection.web";

export default function PublicRefundProtection({
  onFormComplete,
  onError,
  onLoaded,
  isEligible = false,
  shouldShow = false,
}: Omit<RefundProtectionProps, "basketType">) {
  const { paymentVenue } = usePublicBasket();
  const { useRetrieveVenueConfiguration } =
    usePublicBasedRefundProtectionConfigurationService();
  const { data: configuration, isFetched } =
    useRetrieveVenueConfiguration(paymentVenue);

  if (!isFetched) {
    return null;
  }

  return (
    <RefundProtection
      basketType={DataProvider.Public}
      onFormComplete={onFormComplete}
      onError={onError}
      onLoaded={onLoaded}
      isEligible={isEligible}
      shouldShow={shouldShow}
      protectionApiKey={configuration?.public_key}
    />
  );
}
